import { Button, Tabs, TabsProps } from "antd";
import { WebDPrivilege, WebDUser } from "api/services/models/WebDUser";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import MessageGrid from "components/messages/MessageCenter";
import NotificationCenter from "components/messages/NotificationCenter";
import { ReactComponent as NotificationIcon } from "Icons/vuesax/message-notif.svg";
import { ReactComponent as MessageIcon } from "Icons/vuesax/sms.svg";
import { ReactComponent as HamburgerIcon } from "Icons/vuesax/menu.svg";
import { ReactComponent as AddSquareIcon } from "Icons/vuesax/add-square-coloured.svg";
import { useLayoutContext } from "components/MainContainer";
import { useEffect, useRef } from "react";

const makeTabsForUser = (user?: WebDUser | null): TabsProps["items"] => [
  {
    key: "1",
    icon: <MessageIcon style={{ fontWeight: "bold", strokeWidth: "2.5" }}  className="anticon" width={".875rem"} height={".875rem"} />,
    label: "Messages",
    children: <MessageGrid />
  },
  {
    key: "2",
    icon: <NotificationIcon className="anticon" width={"14px"} height={"14px"} />,
    label: "Notifications",
    disabled: true, //!user?.isInternalUser(),
    children: <NotificationCenter />
  }
];

interface MessagerGridRef {
  openNewMessageDialog: () => void;
}

const Mailbox = () => {
  const { webDUser,  } = useTDAuthentication();
  const { toggleDrawer, isSmallScreen } = useLayoutContext();
  const messagerGridRef = useRef<MessagerGridRef>(null);
  const handleOpenNewMessage = () => {
    if (messagerGridRef.current) {
      messagerGridRef.current.openNewMessageDialog();
    }
  };

  useEffect(() => {
      document.body.classList.toggle("no-scroll", !isSmallScreen);
  }, [isSmallScreen]);
  
  return (<>
  {!isSmallScreen ? (
    <div className="container">
      <div className="header">
        <div className="header-title">
          <span>Messages</span>
        </div>
      </div>
      <Tabs
        defaultActiveKey="1"
        items={makeTabsForUser(webDUser)?.filter(t => !t.disabled)}
        destroyInactiveTabPane={true}></Tabs>
    </div>):(
      <div className="container">
      <div className="header">
        <div className="header-title">
          {" "}
          {isSmallScreen && (
            <Button
              type="text"
              icon={<HamburgerIcon />}
              onClick={toggleDrawer}
              className="hamburger-menu-button"
              style={{ marginRight: ".25rem" }}
            />
          )}
          <span style={{alignItems:"center", display:"flex"}}>Messages 
          {webDUser?.hasPrivilege(WebDPrivilege.CreateNewMessage) &&<AddSquareIcon color="#1868db" width={"1.5rem"} height={"1.5rem"} style={{marginLeft:"10.56rem"}} onClick={handleOpenNewMessage}/>}</span>
        </div>
      </div>
      <MessageGrid ref={messagerGridRef}/>
    </div>
    )}</>
  );
};

export default Mailbox;
